import { getTimeDisplay } from "../../util/timeUtil";
import { TotalVerseCardsStats } from "./VerseCardsData";

/**
 * Stats display for verse cards, both during and at the end of the run
 */
export function VCStatsDisplay({
  stats,
  remaining,
  timeTaken,
}: {
  stats: TotalVerseCardsStats;
  remaining?: number;
  timeTaken?: number;
}) {
  const getPercent = (correct: number, incorrect: number) => {
    return correct + incorrect === 0
      ? "0.00"
      : Math.round((correct * 1000) / (correct + incorrect)) / 10.0;
  };

  const includeReview = stats.totalVerses < stats.correct + stats.incorrect;
  return (
    <div style={{ marginRight: 30 }}>
      <div>{`Total Verses: ${stats.totalVerses}`}</div>
      <div>{`Correct: ${stats.correct}`}</div>
      <div>{`Incorrect: ${stats.incorrect}`}</div>
      <div>
        {`Percentage Correct: ${getPercent(
          stats.absCorrect,
          stats.absIncorrect
        )}${
          includeReview
            ? ` (${getPercent(stats.correct, stats.incorrect)})`
            : ""
        }`}
      </div>
      {remaining && <div>{`Verses Remaining: ${remaining}`}</div>}
      <div>{`Total Time: ${getTimeDisplay(stats.absTime)}${
        includeReview ? ` (${getTimeDisplay(stats.time, false)})` : ""
      }`}</div>
      {timeTaken !== undefined && (
        <div>{`Time This Verse: ${getTimeDisplay(timeTaken)}`}</div>
      )}
      {(stats.correct > 0 || stats.incorrect > 0) && (
        <div>
          {`Average Time: ${getTimeDisplay(
            stats.absTime / (stats.absCorrect + stats.absIncorrect)
          )}${
            includeReview
              ? ` (${getTimeDisplay(
                  stats.time / (stats.correct + stats.incorrect),
                  false
                )})`
              : ""
          }`}
        </div>
      )}
    </div>
  );
}
